import WorkflowDefinitions from './WorkflowDefinitions'

export default WorkflowDefinitions
